// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"CommentList_ComponentHolder__1vgF1","DateOrder":"CommentList_DateOrder__DvfNP"};